import { action, observable } from 'mobx';
import { IReferralCampaign } from '~/components/Referral/components/ReferralsPage/types';

export class CampaignDetailsStore {
    @observable campaignDetails: IReferralCampaign = <IReferralCampaign>{};

    @action
    setCampaignDetails(details: IReferralCampaign) {
        this.campaignDetails = details;
    }
}

export const campaignDetailsStore = new CampaignDetailsStore();
